<template>
  <div class="h-dialogContainer">
    <p>{{$t('System.remoteTip')}}</p>
    <div class="row h-row-inputBox">
      <form id="createGroupForm">
        <div class="row h-row-inputBox">
          <div class="col-sm-6 h-col-inputBox">
            <div class="form-group h-col-inputBox">
              <div class="e-float-input">
                <div class="h-inputLit">*{{$t('System.userGroupName')}}</div>
                <input
                class="e-input"
                :placeholder='$t("System.userGroupName")'
                id="groupName"
                name="GroupName"
                @change="setChildProps"
                v-model="groupName"/>
              </div>
            </div>
          </div>
          <div class="col-sm-12 h-col-inputBox">
            <div class="form-group h-col-inputBox">
              <div class="e-float-input">
                <div class="h-inputLit">{{$t('System.description')}}</div>
                <ejs-textbox
                  class="e-input"
                  :placeholder='$t("System.description")'
                  id="groupDescription"
                  name="Description"
                  @change="setChildProps"
                  v-model="description"
                  :multiline="true"
                />
              </div>
            </div>
          </div>
      </div>
      </form>
    </div>
    <div class="h-system-trunk">
      <div class="h-system-trunka">
        <div class="h-system-trunk-searchbox">
          <div class="h-system-trunk-search">
            <input
              class="e-input"
              :placeholder='$t("System.inputUser")'
              @keyup.enter="getOptionalUser"
              v-model="optionalKey"
            />
          </div>
        </div>
        <div class="h-system-grida">
          <ejs-grid
            ref="opGrid"
            height='312px'
            :allowResizing='true'
            :dataSource="optionalUser"
            :allowSelection="true"
            :rowSelected="setButtonState"
            :rowDeselected="setButtonState"
            :allowFiltering="true"
            :created="opCreated"
          >
            <e-columns>
              <e-column type="checkbox" width="30" textAlign="center"></e-column>
              <e-column
                field="name"
                :headerText='$t("System.optionalUser")'
                width="120"
                textAlign="center"
              ></e-column>
            </e-columns>
          </ejs-grid>
        </div>
      </div>
      <div class="h-system-trunkc">
        <div class="h-system-trunk-btnbox">
          <div class="h-system-trunkc-btna">
            <ejs-button
              ref="addButton"
              iconCss="icon hero-icon hero-icon-add-small hero-system-icon-add-small"
              cssClass="e-small e-round"
              :isPrimary="true"
              @click.native="addSelectedUser"
              :disabled="addButtonBool"
            ></ejs-button>
          </div>
          <div class="h-system-trunkc-btnb">
            <ejs-button
              ref="delButton"
              iconCss="icon hero-icon hero-icon-remove-small"
              cssClass="e-small e-round"
              :isPrimary="true"
              @click.native="delSelectedUser"
              :disabled="delButtonBool"
            ></ejs-button>
          </div>
        </div>
      </div>
      <div class="h-system-trunkb">
        <div class="h-system-trunk-searchbox">
          <div class="h-system-trunk-search">
            <input
              class="e-input"
              :placeholder='$t("System.inputUser")'
              @keyup.enter="getSelectedUser"
              v-model="selectedKey"
            />
          </div>
        </div>
        <div class="h-system-grida">
          <ejs-grid
            ref="seGrid"
            height='312px'
            :allowResizing='true'
            :dataSource="selectedUser"
            :allowSelection="true"
            :rowSelected="setButtonState"
            :rowDeselected="setButtonState"
            :allowFiltering="true"
            :created="seCreated"
          >
            <e-columns>
              <e-column type="checkbox" width="30" textAlign="center"></e-column>
              <e-column
                field="name"
                :headerText='$t("System.selectedUser")'
                width="120"
                textAlign="center"
              ></e-column>
            </e-columns>
          </ejs-grid>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import mixin from '../../mixin/mixin';
import { Filter } from "@syncfusion/ej2-vue-grids";

export default {
  name: "CreateGroup",
  mixins: [mixin],
  props: {
    editParams: {},
    optionalParams: Array,
    selectedParams: Array
  },
  data() {
    return {
      addButtonBool: true,
      delButtonBool: true,
      groupName: "",
      description: "",
      formObj: "",
      optionalUser: [], // [{},{}]
      selectedUser: [],
      tempOptional: [], // [1,2,3]
      tempSelected: [],
      optionalKey: "",
      selectedKey: "",
      inputNames: ['GroupName','Description'],
      rules: {
        GroupName: { required: true, regex: 'specialWordWithSpace' , maxLength:32 },
        Description: { maxLength:128 }
      }
    };
  },
  methods: {
    setChildProps() {
      this.optionalUser = [];
      this.selectedUser = [];
      this.tempOptional.forEach(e => {
        this.optionalUser.push({ name: e });
      });
      this.tempSelected.forEach(e => {
        this.selectedUser.push({ name: e });
      });
      let childProps = {
        groupName: this.groupName,
        describe: this.description,
        optionalUser: this.optionalUser,
        selectedUser: this.selectedUser
      };
      this.$emit("childProps", childProps);
    },
    // 左右增加显示添加（伪添加）
    addSelectedUser() {
      let opSelUser = this.$refs.opGrid.ej2Instances.getSelectedRecords();
      let tempData = []; // [1,2,3]
      opSelUser.forEach(e => {
        tempData.push(e.name);
      });
      this.dataSourceAdd(this.tempSelected, tempData);
      this.dataSourceRemove(this.tempOptional, tempData);
      this.setChildProps();
      this.setButtonState();
      const temp = this.$refs.seGrid.$el.childNodes[2].firstChild.firstChild.childNodes[1].firstChild.childNodes[0].firstChild.firstChild;
      if (temp) {
        temp.classList.remove('e-checkbox-disabled');
      }
    },
    delSelectedUser() {
      let selectedUser = this.$refs.seGrid.ej2Instances.getSelectedRecords();
      let tempData = [];
      selectedUser.forEach(e => {
        tempData.push(e.name);
      });
      this.dataSourceAdd(this.tempOptional, tempData);
      this.dataSourceRemove(this.tempSelected, tempData);
      this.setChildProps();
      this.setButtonState();
      const temp = this.$refs.opGrid.$el.childNodes[2].firstChild.firstChild.childNodes[1].firstChild.childNodes[0].firstChild.firstChild;
      if (temp) {
        temp.classList.remove('e-checkbox-disabled');
      }
    },
    dataSourceAdd(tempSrc, tempAdd) {
      tempAdd.forEach(e => {
        tempSrc.push(e);
      });
    },
    dataSourceRemove(tempSrc, tempDel) {
      tempDel.forEach(e => {
        let index = tempSrc.indexOf(e);
        if (index != -1) {
          tempSrc.splice(index, 1);
        }
      });
    },
    setButtonState() {
      let opResult = [];
      let seResult = [];
      if (this.$refs.opGrid != null) {
        opResult = this.$refs.opGrid.ej2Instances.getSelectedRecords();
      }
      if (this.$refs.seGrid != null) {
        seResult = this.$refs.seGrid.ej2Instances.getSelectedRecords();
      }
      if (opResult.length == 0) {
        this.addButtonBool = true;
      } else {
        this.addButtonBool = false;
      }
      if (seResult.length == 0) {
        this.delButtonBool = true;
      } else {
        this.delButtonBool = false;
      }
    },
    validate() {
      return this.formObj.validate();
    },
    bindValidate() {
      this.formObj = this.validateForm('createGroupForm', this.inputNames, this.rules);
    },
    getOptionalUser() {
      // 前台过滤
      if (this.optionalKey == "") {
        this.$refs.opGrid.clearFiltering();
        return null;
      }
      this.$refs.opGrid.filterByColumn("name", "contains", this.optionalKey);
    },
    getSelectedUser() {
      // 前台过滤
      if (this.selectedKey == "") {
        this.$refs.seGrid.clearFiltering();
        return null;
      }
      this.$refs.seGrid.filterByColumn("name", "contains", this.selectedKey);
    },
    opCreated() {
      this.$refs.opGrid.ej2Instances
        .getHeaderTable()
        .querySelector(".e-filterbar").style.display = "none";
    },
    seCreated() {
      this.$refs.seGrid.ej2Instances
        .getHeaderTable()
        .querySelector(".e-filterbar").style.display = "none";
    }
  },
  watch: {
    editParams() {
      this.groupName = this.editParams.groupName;
      this.description = this.editParams.describe;
      document.getElementById('groupName').disabled = true;
      deep: true;
    },
    optionalParams() {
      this.optionalUser = this.optionalParams;
      this.tempOptional = [];
      this.optionalUser.forEach((item, index) => {
        if (this.tempSelected.indexOf(item.name) != -1) {
          this.optionalUser.splice(index, 1);
        }
      });
      this.optionalUser.forEach(e => {
        this.tempOptional.push(e.name);
      });
      this.setChildProps();
      deep: true;
    },
    selectedParams() {
      this.selectedUser = this.selectedParams;
      this.tempSelected = [];
      this.selectedUser.forEach(e => {
        this.tempSelected.push(e.name);
      });
      this.setChildProps();
      deep: true;
    }
  },
  provide: {
    grid: [Filter]
  }
};
</script>

<style>
</style>
